'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniCompareWrapper = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _ComparisonTable = require('acq-components/lib/composite-components/ComparisonTable/ComparisonTable');

var _miniCompare = require('../../redux/selectors/miniCompare');

var selectors = _interopRequireWildcard(_miniCompare);

var _common = require('../../redux/selectors/common');

var _componentHelpers = require('../../utils/component-helpers');

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniCompareWrapper = function MiniCompareWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      dtmHelper = _ref.dtmHelper,
      _ref$callToActionDTMS = _ref.callToActionDTMSection,
      callToActionDTMSection = _ref$callToActionDTMS === undefined ? _dtmConsts.DTM_CONSTS.middle : _ref$callToActionDTMS,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator', 'dtmHelper', 'callToActionDTMSection']);

  if (!props.miniCompareData || !props.cards || !props.cards.length) return null;

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    { styles: styles.fullWidthBackground },
    _react2.default.createElement(_ComparisonTable.ComparisonTable, {
      title: props.title,
      titleProps: { Component: 'h2' },
      subTitle: props.subTitle,
      cards: props.cards,
      CardNameComponent: 'h3',
      compareButtonProps: {
        children: props.compareButtonLabel,
        className: (0, _lodash2.default)(styles, 'comparisonTable.compareButton'),
        onClick: (0, _componentHelpers.getCompareButtonOnClickHandler)({
          dtmHelper: dtmHelper,
          cardShortName: props.cardShortName,
          compareLink: props.compareLink,
          section: callToActionDTMSection
        }),
        title: props.compareHoverTitle
      },
      expandButtonLabel: props.showMoreButtonLabel,
      collapseButtonLabel: props.showLessButtonLabel,
      styles: {
        title: styles.titleStyles,
        compareTable: styles.comparisonTable,
        button: styles.comparisonTableButton
      },
      onClick: function onClick(url) {
        window.location.href = url;
      },
      onExpandCollapse: function onExpandCollapse(actionResult) {
        if (actionResult) {
          (0, _dtmEvent.triggerDTMEvent)(dtmHelper.getDtmClickEventObj(actionResult.tableExpanded === true ? _dtmConsts.DTM_CONSTS.actionShowMore : _dtmConsts.DTM_CONSTS.actionShowLess, _dtmConsts.DTM_CONSTS.compare));
        }
      },
      namespace: 'compare-table',
      qeId: props.qeId
    })
  );
};

exports.MiniCompareWrapper = MiniCompareWrapper;
var mapStateToProps = function mapStateToProps(state) {
  return {
    miniCompareData: selectors.getCompareCards(state),
    compareButtonLabel: selectors.getCompareButtonLabel(state),
    showMoreButtonLabel: selectors.getShowMoreButtonLabel(state),
    showLessButtonLabel: selectors.getShowLessButtonLabel(state),
    title: selectors.getTitle(state),
    subTitle: selectors.getSubTitle(state),
    cards: selectors.getCards(state),
    cardShortName: selectors.getCardShortName(state),
    compareHoverTitle: (0, _common.getCompareHoverTitle)(state),
    compareLink: selectors.getCompareLink(state),
    qeId: selectors.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MiniCompareWrapper);